module.exports = "<!-- <div class=\"sidebar-footer\"></div> -->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-sidebar-footer/app-sidebar-footer.component.html
// module id = ./src/app/components/app-sidebar-footer/app-sidebar-footer.component.html
// module chunks = main